import React, { useRef, useEffect } from 'react'
import { List, Alert, Button, CircularProgress } from '@mui/material'
import ChatMessage from './ChatMessage'
import useMessages from '../util/hooks/useMessages'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const pageStyle = {
  messageList: { m: '0px 3px 0px 3px', overflow: 'auto' }
}

const MessagesList = ({ chatId, isTyping, isFailed, resendRequest, lastMessage }) => {
  const { messages, loading, error } = useMessages(chatId)
  const messagesEndRef = useRef()

  const { t } = useTranslation()

  // scroll to bottom
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'instant' })
  }, [messages, lastMessage])

  if (!chatId) {
    return (
      <><ChatMessage key={-1} uniqueId={-1} content={t('welcome_message')} role={'assistent'} ></ChatMessage></>
    )
  } else if (loading) {
    return <CircularProgress />
  } else if (error) {
    return <Alert>error</Alert>
  }

  return (
    <>
        <List sx={pageStyle.messageList}>
              <ChatMessage key={-1} uniqueId={-1} content={t('welcome_message')} role={'assistent'} ></ChatMessage>
                {messages.map((message, index) => {
                  return <ChatMessage key={index} uniqueId={index} content={message.content} role={message.role}/>
                })}
                {(isFailed || isTyping) && <ChatMessage key={-3} uniqueId={-3} content={lastMessage.content} role={lastMessage.role}></ChatMessage>}
                {isTyping && <ChatMessage key={-2} uniqueId={-2} content={'AI is typing...'} role={'assistent'} ></ChatMessage>}
                {isFailed && <><Alert severity="warning" action={<Button color="inherit" onClick={resendRequest} size="small">RESEND</Button>}>Something went wrong. Please try again in a few seconds.</Alert> </>}
                <div ref={ messagesEndRef }></div>
        </List>
    </>
  )
}

MessagesList.propTypes = {
  chatId: PropTypes.string,
  isTyping: PropTypes.bool,
  isFailed: PropTypes.bool,
  resendRequest: PropTypes.func.isRequired,
  lastMessage: PropTypes.object
}
export default MessagesList
